function toGoalId(value: unknown): number | null {
	const id = typeof value === 'string' && /^\d+$/.test(value) ? Number(value) : value;

	return typeof id === 'number' && Number.isInteger(id) && id > 0 ? id : null;
}

// the goal parts of a socket payload (ids may come as strings)
export interface GoalsPayload {
	goals?: ({ id?: unknown } | null)[];
	goal?: { id?: unknown } | null;
	deletedRecords?: { goals?: unknown[] };
}

/**
 * Ids of the goals a socket payload changed or deleted, each once.
 */
export function getChangedGoalIds(data: GoalsPayload): number[] {
	const changed: unknown[] = Array.isArray(data.goals) ? data.goals.map((goal) => goal?.id) : [];
	// some payloads carry a single goal record instead of a goals list
	changed.push(data.goal?.id);
	const deleted: unknown[] = Array.isArray(data.deletedRecords?.goals)
		? data.deletedRecords.goals
		: [];
	const ids = new Set<number>();

	[...changed, ...deleted].forEach((value) => {
		const id = toGoalId(value);
		if (id !== null) {
			ids.add(id);
		}
	});

	return [...ids];
}
